import React, {Component, PropTypes} from 'react';

let $ = window.jQuery;

export default class TextAreaField extends Component {
    static propTypes = {
        val: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired,
        maxlength: PropTypes.string
    };

    state = {
        val: '',
        showHelp: 'none'
    };

    handleChange = (e) => {
        this.setState({val: e.target.value});
        this.props.onChange(e);
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });

        $('#'+this.props.id).maxlength({
            alwaysShow: true,
            warningClass: "label label-success",
            limitReachedClass: "label label-danger",
            separator: ' out of ',
            preText: 'You typed ',
            postText: ' chars available.',
            validate: true
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        var className = this.state.val ? 'form-control edited' : 'form-control';

        return (
            <div className="form-group form-md-line-input form-md-floating-label">
                <textarea className={className} id={this.props.id}
                          onFocus={(e) => this.setState({showHelp: 'inline'})}
                          onBlur={(e) => this.setState({showHelp: 'none '})}
                          name={this.props.id}
                          onChange={this.handleChange}
                          maxLength={this.props.maxlength ? this.props.maxlength : 5000 }
                          value={this.state.val}/>

                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block" style={{ display: this.state.showHelp }}>{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/TextAreaField.js
 **/